import { useState } from "react";
import { toast } from "sonner";
import { g, p, eur } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Archive, CheckCircle2, AlertTriangle } from "lucide-react";

export const ChiusuraSerata = ({ onDone }) => {
  const { t } = useI18n();
  const [pre, setPre] = useState(null);
  const [busy, setBusy] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        data-testid="close-evening-btn"
        onClick={async () => {
          try {
            setPre(await g("/evening/preclose"));
          } catch {
            toast.error(t("sr.precloseErr"));
          }
        }}
      >
        <Archive className="mr-1.5 h-4 w-4" /> {t("sr.close")}
      </Button>

      <Dialog open={!!pre} onOpenChange={(o) => !o && setPre(null)}>
        <DialogContent className="max-w-md" data-testid="preclose-dialog">
          <DialogHeader>
            <DialogTitle>{t("sr.precloseTitle")}</DialogTitle>
          </DialogHeader>
          {pre && (
            <div className="space-y-3">
              <p className="text-sm text-slate-500">{t("sr.precloseIntro")}</p>
              <div className="space-y-2">
                {pre.checks.map((c) => (
                  <div
                    key={c.id}
                    data-testid={`preclose-${c.id}`}
                    className={`flex items-start gap-2 rounded-lg border p-3 text-sm ${c.ok ? "border-slate-200" : "border-amber-200 bg-amber-50"}`}
                  >
                    {c.ok ? (
                      <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
                    ) : (
                      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
                    )}
                    <span>{c.label}</span>
                  </div>
                ))}
              </div>
              {pre.to_collect > 0 && (
                <p className="rounded-lg bg-rose-50 p-3 text-sm font-medium text-rose-900" data-testid="preclose-warning">
                  {t("sr.precloseMoney", { v: eur(pre.to_collect) })}
                </p>
              )}
            </div>
          )}
          <DialogFooter className="gap-2 sm:gap-2">
            <Button variant="outline" onClick={() => setPre(null)} data-testid="preclose-cancel">
              {t("g.cancel")}
            </Button>
            <Button
              disabled={busy}
              data-testid="preclose-confirm"
              onClick={async () => {
                setBusy(true);
                try {
                  await p("/evening/close");
                  toast.success(t("sr.closed"), { description: t("sr.closedSub") });
                  setPre(null);
                  onDone();
                } finally {
                  setBusy(false);
                }
              }}
            >
              {pre?.ready ? t("sr.precloseOk") : t("sr.precloseAnyway")}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
